import { useEffect, useState, useRef } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuthContext } from '../context/AdminAuthContext';
import AdminSidebar from './AdminSidebar';
import AdminTopBar from './AdminTopBar';
import { supabase } from '../../lib/supabase';
import './AdminLayout.css';

const PAGE_TITLES = {
  dashboard: { title: 'Dashboard', subtitle: 'Platform aktivitesi ve istatistiklerine genel bakış' },
  users: { title: 'Kullanıcılar', subtitle: 'Kayıtlı kullanıcıları görüntüleyin ve platform aktivitelerini inceleyin' },
  notes: { title: 'Notlar', subtitle: 'Yüklenen notları, AI kontrol sonuçlarını ve not meta verilerini inceleyin' },
  matches: { title: 'Eşleşmeler', subtitle: 'Öğrenci not teklifleri ve arama ihtiyaçlarının nasıl eşleştiğini takip edin' },
  messages: { title: 'Mesajlar', subtitle: 'Kullanıcılar arasındaki mesaj aktivitesini görüntüleyin' },
  notifications: { title: 'Bildirimler', subtitle: 'Kullanıcılara gönderilen uygulama bildirimlerini görüntüleyin' },
  courses: { title: 'Ders Seçenekleri', subtitle: 'Uygulamada kullanılan fakülte, bölüm, dönem ve ders isimlerini yönetin' },
  favorites: { title: 'Favori İstatistikleri', subtitle: 'Öğrencilerin en çok kaydettiği notları ve dersleri anlayın' },
  settings: { title: 'Ayarlar', subtitle: 'Admin paneli ve platform ayarlarını yönetin' },
  login: { title: '', subtitle: '' },
};

export default function AdminLayout() {
  const { session, isAdmin, loading, signOut } = useAdminAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const didRedirect = useRef(false);

  useEffect(() => {
    if (!loading && !didRedirect.current) {
      if (!session || !isAdmin) {
        didRedirect.current = true;
        navigate('/admin/login', { replace: true });
      }
    }
    if (session && isAdmin) didRedirect.current = false;
  }, [session, isAdmin, loading, navigate]);

  useEffect(() => {
    if (!session || !isAdmin) return;
    supabase.from('app_settings').select('maintenance_mode').eq('id', 'general').maybeSingle()
      .then(({ data }) => { if (data) setMaintenanceMode(data.maintenance_mode); });
  }, [session, isAdmin]);

  const segment = location.pathname.split('/').filter(Boolean)[1] || 'dashboard';
  const { title, subtitle } = PAGE_TITLES[segment] || PAGE_TITLES.dashboard;

  if (loading) {
    return (
      <div className="admin-loading-screen">
        <div className="admin-spinner" />
        <p>Yükleniyor...</p>
      </div>
    );
  }

  if (!session || !isAdmin) return null;

  return (
    <div className="admin-layout">
      <AdminSidebar maintenanceMode={maintenanceMode} onSignOut={signOut} />
      <div className="admin-main">
        <AdminTopBar title={title} subtitle={subtitle} session={session} />
        <div className="admin-content">
          <Outlet context={{ maintenanceMode, setMaintenanceMode }} />
        </div>
      </div>
    </div>
  );
}
